import { HtmlIds } from "@/common/constants";
import { Flex, GapSize } from "@/components/atoms/flex";
import { FluentProvider, teamsLightTheme } from "@fluentui/react-components";
import { EmailConversationProps } from "./types";
import { useStyles } from "./style";

export const EmailConversation = (props: EmailConversationProps) => {
	const classes = useStyles();

	const anchorIndex =
		props.editor && props.editorAfterMessageId != null
			? props.emails.findIndex(
					(email) => email?.key === props.editorAfterMessageId
				)
			: -1;

	const body =
		anchorIndex >= 0 ? (
			<>
				{props.emails.slice(0, anchorIndex + 1)}
				{props.editor}
				{props.emails.slice(anchorIndex + 1)}
			</>
		) : (
			<>
				{props.emails}
				{props.editor}
			</>
		);

	return (
		<div ref={props.scrollRef} className={classes.conversationContainer}>
			<FluentProvider
				theme={teamsLightTheme}
				className={classes.headerThemeProvider}
			>
				{props.header}
			</FluentProvider>
			<FluentProvider
				theme={teamsLightTheme}
				className={classes.themeProvider}
				id={HtmlIds.EditorFluentProvider}
			>
				<Flex column className={classes.emailsContainer} gap={GapSize.Small}>
					<Flex column gap={GapSize.Small}>
						{body}
					</Flex>
				</Flex>
			</FluentProvider>
		</div>
	);
};
